import styled from "styled-components";
import {
  getBorderRadius,
  getColor,
  getFadeInAnimation,
  getSize,
  responsive,
} from "~/helpers/style";
import { UIProps } from "~/types/style";

interface IModal extends UIProps {
  minWidth: string | number;
  maxWidth?: string | number;
  maxHeight?: string;
}

interface IModalScrollable extends UIProps {
  padding?: string;
}

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(8, 31, 64, 0.45);
  backdrop-filter: blur(2px);
  z-index: 2;
  // Fade in the modal once added to the DOM
  ${getFadeInAnimation(0.3)}
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${responsive("tablet", true)} {
    align-items: center;
    justify-content: center;
  }
`;

export const ModalContent = styled.div<IModal>`
  position: fixed;
  background: white;
  min-width: ${({ minWidth }) => (minWidth ? minWidth : "90%")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "90%")};
  width: ${({ width }) => (width ? width : "90%")};
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: ${getBorderRadius(1.2)};
  max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : "80%")};
  overflow: auto;
  padding: 0 !important;
  @media (max-width: 600px) {
    position: static;
    height: auto;
    min-width: 0;
    border-radius: 15px;
    left: unset;
    transform: none;
    width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
    margin-inline: 16px;
  }
`;

export const ModalScrollWrapper = styled.div<IModalScrollable>`
  max-height: 100%;
  overflow: auto;
  padding: ${getSize(3.2)};
  border-radius: inherit;
  width: 100%;
  padding: ${({ padding }) => (padding ? padding : getSize(3.2))};
  height: 100%;
  ${responsive("tablet")} {
    padding: ${({ padding }) => (padding ? padding : getSize(5.8))};
  }
  @media (max-width: 600px) {
    overflow-x: hidden;
  }
`;

export const CloseContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  padding: ${getSize(1.2)};
  ${responsive("tablet")} {
    padding: ${getSize(2.4)};
  }
`;

export const FixedElement = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${getColor("background")};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 3;
`;
